import { render, staticRenderFns } from "./MemberActivitySubmissionWrapper.vue?vue&type=template&id=8182cd7e"
import script from "./MemberActivitySubmissionWrapper.vue?vue&type=script&lang=js"
export * from "./MemberActivitySubmissionWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports